import { Text, Badge } from "@chakra-ui/react";

const NotificationCount = ({
  label,
  count,
  badgeBg = "rgba(18, 183, 106, 0.1)",
  badgeColor = "green.400",
  hideWhenEmpty = false,
  maxCount,
}) => {
  if (hideWhenEmpty && !count) {
    return <Text mr="1">{label}</Text>;
  }

  const displayCount = maxCount && count > maxCount ? `${maxCount}+` : count;

  return (
    <>
      <Text mr="1">{label}</Text>
      <Badge
        w="24px"
        fontSize="0.6rem"
        borderRadius="4px"
        padding="4px"
        bg={badgeBg}
        color={badgeColor}
      >
        {displayCount}
      </Badge>
    </>
  );
};

export default NotificationCount;
